import "./index.css";

const EmployeeView = ({ employeeData }) => {
  if (!employeeData) {
    return null;
  }

  return (
    <>
      <div className="row">
        <div className="col-md-6 details_list">
          <p className="view_head">Name</p>
          <p>:</p>
          <p className="view_values">{employeeData?.first_name}</p>
        </div>
        <div className="col-md-6 details_list">
          <h3 className="view_head">Email</h3>
          <p>:</p>
          <h3 className="view_values">{employeeData?.email}</h3>
        </div>
        <div className="col-md-6 details_list">
          <h3 className="view_head">Phone Number</h3>
          <p>:</p>
          <h3 className="view_values">{employeeData?.phone_number}</h3>
        </div>{" "}
        <div className="col-md-6 details_list">
          <h3 className="view_head">Rank</h3>
          <p>:</p>
          <h3 className="view_values">{employeeData?.rank}</h3>
        </div>
        {/* <div className="col-md-6 details_list">
          <h3 className="view_head">Designation</h3>
          <p>:</p>
          <h3 className="view_values">{employeeData?.designation}</h3>
        </div>{" "} */}
        {/* <div className="col-md-6 details_list">
          <h3 className="view_head">ID TYPE & VALUE</h3>
          <p>:</p>
          <h3 className="view_values">{`${employeeData?.id_type} - ${
            employeeData?.id_type === "NRIC"
              ? employeeData?.nric_masking
              : employeeData?.id_type === "FIN"
              ? employeeData?.fin_masking
              : employeeData?.passport
          }`}</h3>
        </div> */}
        <div className="col-md-12 details_list">
          <h3 className="view_head">Address</h3>
          <p>:</p>
          <h3 className="view_values">
            {employeeData?.address_detail?.address}
          </h3>
        </div>{" "}
        <div className="col-md-6 details_list">
          <h3 className="view_head">Country</h3>
          <p>:</p>
          <h3 className="view_values">
            {employeeData?.address_detail?.country}
          </h3>
        </div>
        <div className="col-md-6 details_list">
          <h3 className="view_head">State</h3>
          <p>:</p>
          <h3 className="view_values">{employeeData?.address_detail?.state}</h3>
        </div>
        <div className="col-md-6 details_list">
          <h3 className="view_head">Zip Code</h3>
          <p>:</p>
          <h3 className="view_values">
            {employeeData?.address_detail?.zipcode}
          </h3>
        </div>
        <div className="col-md-6 details_list">
          <h3 className="view_head">Role</h3>
          <p>:</p>
          <h3 className="view_values">
            {employeeData?.role?.name?.toUpperCase()}
          </h3>
        </div>
      </div>
    </>
  );
};

export default EmployeeView;
